module.exports = __webpack_public_path__ + "media/images/emblems/Horrenbach_Buchen-coat_of_arms-f5254115d95e14f08e64163e73e5a37a.svg";